import FalconCardHeader from 'components/common/FalconCardHeader';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ChangePassword = () => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = e => {
    console.log(formData);
    e.preventDefault();
  };

  return (
    <Card className="mb-3">
      <FalconCardHeader title={t('changePassword')} />
      <Card.Body className="bg-light">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="oldPassword">
            <Form.Label>{t('oldPassword')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.oldPassword}
              name="oldPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="newPassword">
            <Form.Label>{t('newPassword')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.newPassword}
              name="newPassword"
              autoComplete="new-password"
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="confirmPassword">
            <Form.Label>{t('confirmPassword')}</Form.Label>
            <Form.Control
              type="password"
              value={formData.confirmPassword}
              autoComplete="new-password"
              name="confirmPassword"
              onChange={handleChange}
            />
          </Form.Group>
          <Button className="w-100" type="submit">
            {t('updatePassword')}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ChangePassword;
